<template>
  <div v-if="showModal" class="side__modal opened" id="modal__adding__customers__docs">
    <div class="">
      <div class="side__modal__content">
        <div class="modal__top">
          <div class="modal__header">
            <h3 class="modal__title">{{ $lang.app.RETURN_APPLICATION_SECTIONS_TO_REWORK }}</h3>
            <span class="modal__close" @click="closeModal">
            <svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
          </div>
        </div>

        <Form class="modal__footer"
              @submit="submit"
              :validation-schema="formSchema">
          <div class="input__group input__add__info">
            <label for="message-input" class="label">{{ this.$lang.app.ACTION_REASON }}</label>
            <Field name="message" v-slot="{ field, errorMessage }">
              <textarea v-bind="field"
                        id="message-input"
                        v-model="form.message"
                        class="input"
                        :class="{'input--fail': errorMessage }"
                        :placeholder="$lang.app.ENTER"/>
              <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
            </Field>
          </div>

          <div class="between__buttons">
            <button type="button" class="button button__modal__close button--cancel"
                    @click="closeModal">{{ $lang.app.CANCEL }}</button>
            <button type="submit" class="relative button button__modal__close"
                    :disabled="submitting">
              {{ $lang.app.RETURN }}
              <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
                <div class="block animate-spin">
                  <RefreshIcon class="w-6 h-6 mirror-y"/>
                </div>
              </div>
            </button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import {Field, Form} from 'vee-validate'
import * as yup from "yup";
import applicationApi from "../../../../api/employee/application";

export default {
  components: {
    Field,
    Form,
  },
  data() {
    return {
      showModal: false,

      application: null,

      submitting: false,
      form: {
        message: '',
      },
      formSchema: yup.object({
        message: yup.string().required(),
      }),
    };
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    submit() {
      this.submitting = true
      applicationApi
          .returnApplicationRemarks(this.application.id, this.form.message)
          .then(() => {
            this.closeModal()
            this.$emitter.emit('refresh-application', {reload: false})
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          }).finally(() => {
        this.submitting = false
      });
    }
  },
  beforeMount() {
    this.$emitter.on('openApplicationReturnRemarksModal', application => {
      this.openModal()
      this.application = application
    })
  },
  beforeUnmount() {
    this.$emitter.off('openApplicationReturnRemarksModal')
  }
}
</script>
